/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Menu from '../../../components/Menu'

import { ToastContainer } from 'react-toastify'
import { useForm } from "react-hook-form"

import { deleteItem, get, put } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { useNavigate, useParams } from 'react-router-dom'

function index() {
  const { id } = useParams()

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const navigate = useNavigate()
  const [clickButton, setClickButton] = useState(false)
  const [sliderCount, setsliderCount] = useState(2)
  const [sliders, setSliders] = useState([{ id : 1 }])
  const [sliderTitle, setSliderTitle] = useState('')

  document.title = 'ویرایش اسلایدر'

  const token = localStorage.getItem('token')

  const timeHandler = () => {
    setsliderCount(sliderCount + 1)
    setSliders(oldArray => [...oldArray, { id : sliderCount}])
  }

  const { register, handleSubmit, reset } = useForm()

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let count = 0
    const sliderArray = []

    let objectFa
    Object.keys(data).forEach(function(key, index) {
      let object
      count++
      console.log(key, data[key])
      if(count%2 === 1) {
        objectFa = { sliderLink: data[key] }
        console.log(object)
      }
      if (count%2 === 0) {
        object = { ...objectFa, sliderPicture: data[key] }
        sliderArray.push(object)
        object = {}
        objectFa = {}
      }
    })

    console.log(sliderArray)

    put(`/api/admin/sliders/${id}?token=${token}`, { title: sliderTitle, slider: sliderArray }).then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/sliders')
        }, 2000)
      }).catch(error => {
        setClickButton(false)
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  useEffect(() => {
    get(`/api/admin/sliders/${id}?token=${token}`)
      .then(response => {
        setSliders(response.data.data[0].slider)
        setSliderTitle(response.data.data[0].title)
        let defaultValues = {}
        reset({ ...defaultValues })
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, reset, token])

  const sliderTitleHandler = (e) => {
    setSliderTitle(e.target.value)
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/sliders/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/sliders')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید اسلایدر مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'slider'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ویرایش اسلایدر
              </div>
            </div>

            <div className='left'>
              <button onClick={e => { 
                setCover(true)
                setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف اسلایدر</button>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ویرایش اسلایدر لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات اسلایدر
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantDetails'>نام اسلایدر * :</label>
                <input id='resturantDetails' onChange={sliderTitleHandler} defaultValue={sliderTitle} type='text' placeholder='محصولات ...' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            {sliders.map((item, index) => (
              <div className='row' key={index} id={item.id}>
                <div className='column'>
                  <label htmlFor='resturantDay'>لینک * :</label>
                  <input id='resturantDay' {...register(`sliderLink${index}`, { required: true, minLength: 3 })} defaultValue={item.sliderLink} type='text' placeholder='لینک' />
                  <small id='resturantDayAlert'>ویژگی باید وارد شود</small>
                </div>
                <div className='column'>
                  <label htmlFor='resturantTime'>لینک تصویر * :</label>
                  <input id='resturantTime' {...register(`sliderPicture${index}`, { required: true, minLength: 3 })} defaultValue={item.sliderPicture} type='text' placeholder='لینک تصویر' />
                  <small id='resturantTimeAlert'>انگلیسی ویژگی باید وارد شود</small>
                </div>
              </div>
            ))}
            <div className="row">
              <div className="add" onClick={timeHandler}>
                +
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپدیت اسلایدر'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index